import React from "react";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import NavBar from "./Components/NavBar";
import Footer from "./Components/Footer";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import HomePage from "./Views/HomePage/HomePage";
import AboutUsPage from "./Views/AboutUsPage/AboutUsPage";
import OurVisionPage from "./Views/OurVisionPage/OurVisionPage";
import BoardMembersPage from "./Views/BoardMembersPage/BoardMembersPage";
import PartnersInSuccessPage from "./Views/PartnersInSuccessPage/PartnersInSuccessPage";
// import ShareholdersPage from "./Views/ShareholdersPage/ShareholdersPage";
import CouponsPage from "./Views/CouponsPage/CouponsPage";
import IssuesPage from "./Views/IssuesPage/IssuesPage";
import ContactUsPage from "./Views/ContactUsPage/ContactUsPage";

function App() {
  return (
    <React.Fragment>
      <NavBar />
      <div className="App">
        <Routes>
          <Route exact path="/" element={<HomePage />} />
          <Route exact path="/about-us" element={<AboutUsPage />} />
          <Route exact path="/our-vision" element={<OurVisionPage />} />
          <Route exact path="/board-members" element={<BoardMembersPage />} />
          <Route
            exact
            path="/partner-in-success"
            element={<PartnersInSuccessPage />}
          />
          {/* <Route exact path="/shareholders" element={<ShareholdersPage />} /> */}
          <Route exact path="/coupons" element={<CouponsPage />} />
          <Route exact path="/issues" element={<IssuesPage />} />
          <Route exact path="/contact-us" element={<ContactUsPage />} />
        </Routes>
      </div>
      <Footer />
    </React.Fragment>
  );
}

export default App;
